import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../lib/AuthContext';
import { useQuestionnaire } from '../../lib/QuestionnaireContext';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const { isAdmin } = useQuestionnaire();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    console.log("Not an admin user, redirecting to questionnaire home");
    return <Navigate to="/questionnaire" replace />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute; 